<div *ngIf="errorMessage !== null" class="fv-plugins-message-container invalid-feedback">
  {{ errorMessage }}
</div>
